const OutcomeLabelPlayerOccurrenceLine = {
    title: 'Example JSON',
    expectedOutput: 'participant2 - Feyenoord 0.21',
    initialDisplayedCode: `{
        "outcomeId": 2950948554,
        "betOffer": {
            "id": 883929922,
            "betOfferType": {
            "id": 127,`,
    moreCode: `
            "name": "betOffer name"
            },
        "place": false,
        "outcomes": [
        {
            "id": 2950948551,
            "label": "Arsenal",
            "type": "OT_OVER",
            "line": 156,
            "participant": "participant1"
        },
        {
            "id": 2950948554,
            "label": "Feyenoord",
            "type": "OT_UNDER",
            "line": 210,
            "participant": "participant2"
        }
        ]
    },
    "event": {
        "awayName": "EventAwayName",
        "homeName": "EventHomeName"
      }
}`,
};

export default OutcomeLabelPlayerOccurrenceLine;
